import {type PressReleaseParameters} from '@/features/press-release-editor-v3/states/press-release';

/**
 * editor version の比較を行う
 * バージョン運用ルールは下記
 * @see https://www.notion.so/fea20dce98c94dc792d9d0e965ca50b0
 *
 * @param a null, undefined の場合は '0.0.0' として扱う
 * @param b null, undefined の場合は '0.0.0' として扱う
 * @returns 同値の場合 0, a > b の場合 1, a < b の場合 -1
 */
export const compareVersion = (
  a: PressReleaseParameters['editorVersion'],
  b: PressReleaseParameters['editorVersion'],
): number => {
  if (a === b) return 0;

  a ||= '0.0.0';
  b ||= '0.0.0';
  const versionA = a.split('.');
  const versionB = b.split('.');

  if (versionA.length !== 3 || versionB.length !== 3)
    throw new Error(`Unexpected version type. (a: ${a}, b: ${b})`);

  for (let index = 0; index < 3; index++) {
    if (versionA[index] > versionB[index]) return 1;
    if (versionA[index] < versionB[index]) return -1;
  }

  return 0; // Unexpected
};

/**
 * メールタイトル変更機能が有効かどうか
 */
export const checkMailTitleFeatureEnable = (
  editorVersion: PressReleaseParameters['editorVersion'],
): boolean => compareVersion(editorVersion, '3.0.0') >= 0;
